import React from 'react'

import './styles.scss'
import InputLabel from 'components/forms/InputLabel'
import ErrorWrapper from 'components/forms/ErrorWrapper'

/**
 * Input text
 * @param {object} props
 * @param {function} props.onChange
 * @param {string} [props.value]
 * @param {boolean} [props.disabled]
 * @param {boolean} [props.required]
 * @param {string} [props.className]
 * @param {string} [props.placeholder]
 * @param {string} [props.htmlFor]
 * @param {string} [props.title]
 * @param {'text'|'url'} [props.type]
 * @param {boolean} [props.displayEdit]
 * @param {function} [props.onClickEdit]
 * @param {string} [props.error]
 * @param {number} [props.minLength]
 *
 * @returns {React.Component}
 */
const InputText = (props) => {
  const {
    value = '', onChange, disabled = false,
    className = '', placeholder = null, required = false,
    htmlFor = null, title = '', onClickEdit, displayEdit = false,
    type = 'text', error = '', minLength = null
  } = props

  return (
    <div className={`nx-input-text ${className}`}>
      <InputLabel
        title={title}
        htmlFor={htmlFor}
        displayEdit={displayEdit}
        onClickEdit={onClickEdit}
      />

      <ErrorWrapper
        text={error}
      >
        <input
          className={`nx-input-text__input ${error ? 'nx-field-error': ''}`}
          type={type}
          id={htmlFor}
          name={htmlFor}
          value={value}
          placeholder={placeholder}
          onChange={({ target: { value } }) => {
            onChange(value)
          }}
          required={required}
          disabled={disabled}
          minLength={minLength}
        />
      </ErrorWrapper>
    </div>
  )
}

export default InputText
